/* eslint-disable require-await */
import { setupWorker } from 'msw/browser';

import config from '../config';
import { handlers as externalSubmissionHandlers } from './externalSubmission/serverHandlers';
import { handlers as feedbackCenterHandlers } from './feedbackCenter/serverHandlers';
import { handlers as formBuilderHandlers } from './formBuilder/serverHandlers';

export async function enableMocking() {
	if (config.mocksEnabled) {
		const worker = setupWorker(
			...[...feedbackCenterHandlers, ...externalSubmissionHandlers, ...formBuilderHandlers],
		);

		return worker.start({
			serviceWorker: {
				// eslint-disable-next-line no-process-env
				url: `${process.env.PUBLIC_URL}/mockServiceWorker.js`,
			},
		});
	}
	return Promise.resolve();
}
